import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { encounterStatusMap } from '../../../../../../../../constants/encounter';
import { STTS_ESOURCE_TYPES } from '../../../../../../../../constants/study/studyTypes';
import { toFormattedBill } from '../../../../../../../../services/financial';
import { NS_COMMON, NSC_ENCOUNTER, NSPP_STIPEND } from '../../../../../../../../services/i18n/namespaces';

export default function useStipendGridData(studyTypes) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  const columns = useMemo(
    function() {
      const isESource = isESourceType(studyTypes);
      return [
        {
          field: 'encounterDate',
          headerName: t(`${NSPP_STIPEND}:table.encounterDate`),
          flex: 1
        },
        {
          field: 'encounterName',
          headerName: t(`${NSC_ENCOUNTER}:encounter`),
          flex: 1
        },
        {
          field: 'encounterStatus',
          headerName: t(`${NS_COMMON}:encounterStatus`),
          flex: 1,
          valueGetter(value) {
            return t(`${NSC_ENCOUNTER}:statuses.${encounterStatusMap[value] || 'Projected'}`);
          }
        },
        {
          field: 'amount',
          headerName: isESource ? t(`${NSPP_STIPEND}:table.amount.paidAmount`) : t(`${NS_COMMON}:amount`),
          flex: 1,
          renderCell({ value, row }) {
            if (value === 0) {
              return null;
            }
            if (isESource) {
              return toFormattedBill(value);
            }
            return (
              <span
                title={
                  row.stipendStatus === 'PROJECTED'
                    ? t(`${NSPP_STIPEND}:table.amount.potentialStipendAmount`)
                    : t(`${NSPP_STIPEND}:table.amount.paidAmount2`)
                }
              >
                {toFormattedBill(value)}
                <HelpOutlineIcon fontSize="small" color="disabled" />
              </span>
            );
          }
        },
        {
          field: 'stipendStatusName',
          headerName: t(`${NSPP_STIPEND}:table.status`),
          flex: 1,
          valueGetter(value) {
            //TODO: Need to be translated in the separate ticket because it requires additional changes and refactoring
            // [ED-11923]
            return value === 'Projected' ? '' : value;
          }
        }
      ];
    },
    [studyTypes, t]
  );

  return [columns, data, setData];
}

function isESourceType(types) {
  return types.some(function(type) {
    return STTS_ESOURCE_TYPES.includes(type);
  });
}
